import ComponentBase from './base/component-base';
import ComponentInitializer from '../libs/component-initializer';
import { EVENT_GLOBAL_NAV_TOGGLE } from '../constants/event';

export default class GlobalNavToggleComponent extends ComponentBase {
  protected isOpen: boolean = false;

  constructor(element: HTMLElement) {
    super(element);
  }

  protected onReady(): void {
    super.onReady();
    this.addEventListeners();
  }

  private toggle(): void {
    this.isOpen = !this.isOpen;
    this.element.classList.toggle('is-active', this.isOpen);
    const event = new CustomEvent(EVENT_GLOBAL_NAV_TOGGLE, {
      detail: {
        isOpen: this.isOpen,
      },
    });
    document.dispatchEvent(event);
  }

  private addEventListeners(): void {
    this.element.addEventListener('click', this.toggle.bind(this));
  }
}

ComponentInitializer.initializeComponent(
  '.j-global-nav-toggle',
  GlobalNavToggleComponent
);
